import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'findKeyByValue',
	pure: false
})
export class FindKeyByValue implements PipeTransform {
	/**
	 * Transform
	 *
	 * @param {any[]} value
	 * @param {number} id
	 * @param {string} property
	 * @returns {any}
	 */
	transform(value: any, list: any[], key?: any): any {
		const foundItem = list.find(item => {
			if ( item.value !== undefined ) {
				return item.value === value;
			}

			return false;
		});

		if ( foundItem ) {
			return key?foundItem[key]:foundItem['key'];
		}
		else if(value){
			return value.toUpperCase().split(' - ').join('_').split(' ').join('_');
		}
		else{
		  return value;
    }
	}
}
